<div class="col-md-12 col-12 col-lg-12 text-center">
    <p class="verification padding16"> Please wait! We are verifying your email</p>
</div>